var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('h5', {
    staticClass: "d-flex align-center pl-3 mb-n1 mt-1"
  }, [_vm._v(" " + _vm._s(_vm.title) + " ")]), _c('refs-select', {
    attrs: {
      "value": _vm.value && _vm.value.ref ? [_vm.value.ref] : [],
      "partnerId": _vm.partnerId,
      "suggested": [],
      "clearable": true,
      "listMode": !_vm.value.ref,
      "hideEditButton": true,
      "categories": [_vm.ResourceEnum.COMPANY, _vm.ResourceEnum.PERSON],
      "hideSuggestions": true,
      "buttonLabel": _vm.$t('invoice.selectFromPersonAndCompany'),
      "scroll": false
    },
    on: {
      "confirm": _vm.setInvoicePartyFromCompanyOrPersonRef,
      "change": _vm.setInvoicePartyFromCompanyOrPersonRef,
      "input": _vm.setInvoicePartyFromCompanyOrPersonRef
    }
  }), _vm.person && _vm.isSideCardActive ? _c('person-side-card', {
    attrs: {
      "value": _vm.person
    },
    on: {
      "close": function close($event) {
        _vm.isSideCardActive = false;
      }
    }
  }) : _vm._e(), _vm.company && _vm.isSideCardActive ? _c('company-side-card', {
    attrs: {
      "value": _vm.company
    },
    on: {
      "close": function close($event) {
        _vm.isSideCardActive = false;
      }
    }
  }) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }